export default class ExtraButtonDTO {
  icon: string = '';
  tooltip: string = '';
  severity: 'success' | 'info' | 'warning' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast' | null | undefined = 'primary';
  label: string = '';
  action!: Function;
  disabled: boolean = false;
  visible: boolean = true;

  constructor(init?: Partial<ExtraButtonDTO>) {
    Object.assign(this, init);
  }

}
